import React from 'react';
import './Insurance.css';


const Insurance = ({ insuranceList = [], nomMutuelle }) => {
  // Si aucune donnée
  if ((!insuranceList || insuranceList.length === 0) && !nomMutuelle) {
    return (
      <div className="insurance-section">
        <h3>Assurances</h3>
        <p className="no-data">Aucune information d'assurance disponible</p>
      </div>
    );
  }

  return (
    <div className="insurance-section">
      <div className="insurance-header">
        <span className="insurance-icon">🛡️</span>
        <h3>Assurances</h3>
      </div>
      <div className="insurance-content">
        {insuranceList && insuranceList.length > 0 && (
          <div className="insurance-item">
            <label>Liste des assurances :</label>
            <ul className="insurance-list">
              {insuranceList.map((ins, index) => (
                <li key={index}>{ins}</li>
              ))}
            </ul>
          </div>
        )}
        {(!insuranceList || insuranceList.length === 0) && nomMutuelle && (
          <div className="insurance-item">
            <label>Mutuelle :</label>
            <p>{nomMutuelle}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Insurance;